import {
	Grid2,
	Typography,
	Checkbox,
	Button,
	InputBase,
	ButtonBase,
} from '@mui/material';
import { helperText } from '../assets/theme/Theme';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { EyeIcon, HideEyeIcon } from '../assets/icons/Icons';
import {
	getRememberMe,
	setAccessToken,
	setRememberMe,
} from '../Utils/AuthUtil';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';
import { LoginResponse } from '../types';
import { loginUser } from '../services/UserService';

const initialErrorState = {
	status: false,
	msg: '',
};

function Login() {
	const navigator = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [remember, setRemember] = useState(0);
	const [emailError, setEmailError] = useState(initialErrorState);
	const [passwordError, setPasswordError] = useState(initialErrorState);
	const [loginStatus, setLoginStatus] = useState(initialErrorState);
	const [show, setShow] = useState(false);

	function onChangeEmail(
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) {
		setEmailError(initialErrorState);
		setEmail(event.target.value);
	}

	function onChangePassword(
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) {
		setPasswordError(initialErrorState);
		setPassword(event.target.value);
	}

	async function logIn() {
		let error = false;
		if (!email || email === '') {
			setEmailError({ status: true, msg: 'Email is Required.' });
			error = true;
		}

		if (email !== '' && email.indexOf('@') === -1) {
			setEmailError({ status: true, msg: 'Invalid Email' });
			error = true;
		}

		if (!password || password === '') {
			setPasswordError({ status: true, msg: 'Password is Required.' });
			error = true;
		}

		if (error) {
			return;
		} else {
			setLoginStatus(initialErrorState);
			const response: LoginResponse | undefined = await loginUser(
				email,
				password,
			);

			if (response?.data?.status === 200) {
				navigator('/chatHistory');
			} else if (response?.data?.status === 400) {
				setLoginStatus({
					status: true,
					msg: 'Email or password is incorrect',
				});
			} else {
				setLoginStatus({
					status: true,
					msg: 'Something went wrong, please try again.',
				});
			}
		}
	}

	const onChangeRememberMe = () => {
		const val: number = Number(getRememberMe());
		if (val === 0 || val === 2) {
			setRemember(1);
			setRememberMe('1');
		}
		if (val === 1) {
			setRemember(0);
			setRememberMe('0');
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '90vh',
			}}>
			<Grid2 container justifyContent={'center'}>
				<Grid2
					container
					flexDirection={'row'}
					justifyContent={'center'}
					alignItems={'center'}>
					<Typography
						variant="h6"
						fontWeight={'700'}
						color={MAIN_THEME_COLOR}
						paddingLeft="8px">
						{`Website Bot Dashboard`}
					</Typography>
				</Grid2>
				<Grid2
					component="div"
					size={{ xs: 12, md: 12 }}
					style={{
						textAlign: 'left',
						border: '1px solid #F4F5F6',
						boxShadow: '0px 10px 110px 1px rgba(59, 59, 59, 0.08)',
						marginTop: '20px',
						paddingTop: '20px',
						padding: '15px',
						borderRadius: '10px',
						backgroundColor: '#FFF',
					}}>
					<Typography
						fontSize={'16px'}
						color={'#7C7C7C'}
						paddingBottom="10px">
						Email
					</Typography>
					<Grid2
						container
						justifyContent={'space-between'}
						alignItems={'center'}
						border={
							passwordError.status
								? '1px solid red'
								: '1px solid #D9D9D9'
						}
						color={'#777E90'}
						paddingX={'15px'}
						borderRadius={'5px'}>
						<InputBase
							type={'text'}
							sx={{
								padding: '4px',
								width: '100%',
								color: '#777E90',
							}}
							error={emailError.status}
							onChange={onChangeEmail}
							onKeyPress={e => e.code === 'Enter' && logIn()}
						/>
					</Grid2>
					<Typography style={helperText}>{emailError.msg}</Typography>
					<Typography
						fontSize={'16px'}
						color={'#7C7C7C'}
						paddingY="10px">
						Password
					</Typography>
					<Grid2
						container
						justifyContent={'space-between'}
						alignItems={'center'}
						border={
							passwordError.status
								? '1px solid red'
								: '1px solid #D9D9D9'
						}
						color={'#777E90'}
						paddingX={'15px'}
						borderRadius={'5px'}>
						<InputBase
							type={show === false ? 'password' : 'text'}
							sx={{
								padding: '4px',
								width: '90%',
								color: '#777E90',
							}}
							error={passwordError.status}
							onChange={onChangePassword}
							onKeyPress={e => e.code === 'Enter' && logIn()}
						/>
						<ButtonBase onClick={() => setShow(!show)}>
							{show ? (
								<HideEyeIcon error={passwordError.status} />
							) : (
								<EyeIcon error={passwordError.status} />
							)}
						</ButtonBase>
					</Grid2>
					<Typography style={helperText}>
						{passwordError.msg}
					</Typography>
					<Grid2 container justifyContent={'space-between'}>
						<Grid2>
							<Checkbox
								style={{
									paddingLeft: '0px',
									paddingRight: '0px',
								}}
								size="small"
								color="success"
								disableRipple
								onChange={() => onChangeRememberMe()}
								checked={remember === 0 ? false : true}
							/>
							<Typography
								variant="subtitle2"
								style={{
									display: 'inline',
									color: '#B1B5C3',
									paddingLeft: '2px',
								}}>
								Remember me
							</Typography>
						</Grid2>
						{/* <a style={{ textDecoration: 'none' }} href="/reset">
								<Typography
									variant="subtitle2"
									color={MAIN_THEME_COLOR}
									style={{ paddingTop: '10px' }}>
									Forgot your password?
								</Typography>
							</a> */}
					</Grid2>
					{loginStatus.status && (
						<Grid2 container justifyContent={'center'}>
							<Typography style={helperText}>
								{loginStatus.msg}
							</Typography>
						</Grid2>
					)}
					<Grid2 container>
						<Button
							onClick={logIn}
							style={{
								width: '100%',
								boxShadow: 'none',
								marginTop: '10px',
								textTransform: 'none',
								backgroundColor: MAIN_THEME_COLOR,
							}}
							variant="contained">
							Log in
						</Button>
					</Grid2>
				</Grid2>
			</Grid2>
		</div>
	);
}

export default Login;
